import { withInstall } from '@code-monkey-ui/utils'
import InputNumber from './src/input-number.vue'

export const ElInputNumber = withInstall(InputNumber)

export default ElInputNumber
export * from './src/input-number'
